module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/more-topic-1.f84147fb.mp4";